import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { calculateDataForVariant } from '../../../calculateFilterPriceData';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * FilterWithPriceProcessor формирует фильтр цены для каждого варанта
 */
export class FilterWithPriceProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const newFilterData = { ...servicePropertyFilterAndOrderState };

    Object.keys(servicePropertyFilterAndOrderState.Variants).map((variantID) => {
      const variantPrice = calculateDataForVariant(
        additionalServiceState.VariantsCalculationResult[variantID] ?? []
      );

      newFilterData.Variants[variantID] = {
        ...servicePropertyFilterAndOrderState.Variants[variantID],
        IsPriceFilterAvailable: variantPrice.Min !== variantPrice.Max,
        PriceFilter: variantPrice,
      };
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState: newFilterData,
    };
  }
}
